module.exports = __webpack_public_path__ + "img/luyuanSignUpBtnBg1.142af2c9.png";